import { useSelector, shallowEqual } from 'react-redux';
import getAvailablePlatformComponents from '../selectors/available-platform-components';

function useAvailablePlatformComponents() {
  return useSelector(getAvailablePlatformComponents, shallowEqual);
}

export default useAvailablePlatformComponents;
